export default __webpack_public_path__ + "static/media/delete_icon.5bc95465.svg";